import { OptionType } from 'components';

export enum InterimStatus {
    Ctt = 'CTT',
    Cdii = 'CDII',
}
// Array of employment status options

export const interimStatusOptions: OptionType[] = [
    { value: InterimStatus.Ctt, label: 'CTT' },
    { value: InterimStatus.Cdii, label: 'CDII' },
]; // Enum for the provided options
